import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '15px',
    },
    label: {
        fontSize: '14px',
        marginBottom: '10px',
        fontWeight: 500,
        lineHeight: '21px',
    }
}));

export default useStyles;